import { render } from "./BundleMetaRoles.vue?vue&type=template&id=91735a20&scoped=true"
import script from "./BundleMetaRoles.vue?vue&type=script&lang=js"
export * from "./BundleMetaRoles.vue?vue&type=script&lang=js"

import "./BundleMetaRoles.vue?vue&type=style&index=0&id=91735a20&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91735a20"]])

export default __exports__